<script>
import moment from "moment";
import "vue-hotel-datepicker/dist/vueHotelDatepicker.css";
import DatePicker from "vue2-datepicker";
import { days } from "@/helpers/global.variable";

// Custom Componetns
import PageHeader from "@/components/page-header";
import UserService from "@/helpers/APIService/user.service";
import errorHandler from "@/helpers/errorHandler";
import { authComputed } from "@/state/helpers";
import appConfig from "@/app.config";

// Room Availability Component

export default {
  page: {
    title: "Room Availability",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    PageHeader,
    DatePicker,
  },
  data() {
    return {
      title: "Room Availability",
      isLoading: true,
      filter: {
        daterange: [],
        start_date: "",
        end_date: "",
        month: "",
        day: "All",
      },
      days,
      roomAvailability: [],
      dates: [],
      roomTypes: [],
      selectedRoomAvailability: {
        id: null,
        available_room: null,
      },
      total: [],
      isBtnLoading: false,
    };
  },
  computed: {
    ...authComputed,
    currentProps() {
      return {
        isLoading: this.isLoading,
      };
    },
  },
  mounted() {
    this.monthSet();
    this.getRoomAvailability();
  },
  methods: {
    // Method is use for submit filter changes
    onSubmit() {
      if (this.filter.month === null) {
        this.filter.month = "";
      }
      this.getRoomAvailability();
    },
    // Method is use for set date as change for filter
    updateDate(date) {
      if (date[0] !== null) {
        this.filter.start_date = date[0];
        this.filter.end_date = date[1];
      } else {
        this.filter.start_date = "";
        this.filter.end_date = "";
      }
      this.getRoomAvailability();
    },
    // Method is use for get room availability based on filter data values
    getRoomAvailability() {
      let filterData = "";
      filterData += "?hotel=" + this.hotel.id;
      if (this.filter.start_date != "" && this.filter.end_date != "") {
        filterData +=
          "&day_date__gte=" +
          moment(this.filter.start_date).format("YYYY-MM-DD");
        filterData +=
          "&day_date__lte=" + moment(this.filter.end_date).format("YYYY-MM-DD");
      }
      if (this.filter.month !== "") {
        // this.filter.month = moment(this.filter.month).format("MM-YYYY");
        filterData +=
          "&day_date__month=" + moment(this.filter.month).format("MM");
      }
      if (this.filter.day != "" && this.filter.day != "All") {
        filterData += "&day_name=" + this.filter.day;
      }
      UserService.getRoomAvailability(filterData)
        .then((roomAvailability) => {
          this.roomAvailability = roomAvailability;
          if (roomAvailability.length !== 0) {
            this.dates = [];
            this.total = [];
            this.roomAvailability[0].room_availability.map((roomData) => {
              this.isLoading = false;

              this.dates.push({
                date: moment(roomData.day_date),
                day: moment(roomData.day_date).format("ddd"),
                class:
                  moment(roomData.day_date).format("dddd") == "Sunday"
                    ? "highlight"
                    : moment(roomData.day_date).format("dddd") == "Saturday"
                    ? "highlight"
                    : "",
              });

              this.total.push({ totalAva: 0, all: 0, occupancy: 0 });
            });
            this.roomAvailability.map((roomData) => {
              this.total.forEach((element, key) => {
                this.total[key].totalAva = parseInt(
                  parseInt(element.totalAva) +
                    parseInt(
                      roomData.room_availability[key] !== undefined
                        ? roomData.room_availability[key].available_room
                        : 0
                    )
                );
                this.total[key].all = parseInt(
                  parseInt(element.all) +
                    parseInt(
                      roomData.room_availability[key] !== undefined
                        ? roomData.room_availability[key].total_room
                        : 0
                    )
                );
                this.total[key].occupancy = parseInt(
                  100 - parseInt((element.totalAva * 100) / element.all)
                );
              });
            });
          }
          this.isBtnLoading = false;
        })
        .catch((error) => {
          errorHandler(error);
          this.isBtnLoading = false;
        });
    },
    selectRoomAvailability(roomRate) {
      this.selectedRoomAvailability.id = roomRate.id;
      this.selectedRoomAvailability.available_room = roomRate.available_room;
    },
    // Method is use for formate date
    formatDate(date) {
      return moment(date).format("DD MMM");
    },
    // Method is use for set default month
    monthSet() {
      const now = new Date();
      this.filter.month = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate()
      );
    },
    // Method is use for reset filter values
    onReset() {
      this.isBtnLoading = true;
      this.filter.start_date = "";
      this.filter.end_date = "";
      this.filter.month = "";
      this.filter.day = "";
      this.monthSet();
      this.getRoomAvailability();
    },
    // Method is use for display tooltip value ,for room availability in percentage
    findOccupancy(ava, total) {
      if (isNaN(parseInt((ava * 100) / total))) {
        return `${parseInt(0)}%`;
      } else {
        return `${parseInt((ava * 100) / total)}%`;
      }
    },
  },
};
</script>

<template>
  <div>
    <PageHeader :title="title" />
    <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <b-form>
              <div class="row mt-2 align-items-end">
                <div class="col-md-4">
                  <label>Date Range</label>
                  <date-picker
                    lang="en"
                    placeholder="Select date to stay"
                    range
                    type="date"
                    v-model="filter.daterange"
                    value-type="format"
                    @change="updateDate"
                  ></date-picker>
                </div>
                <div class="col-md-3">
                  <label>Month</label>
                  <date-picker
                    v-model="filter.month"
                    type="month"
                    lang="en"
                    placeholder="Select Month"
                    @change="onSubmit"
                  ></date-picker>
                </div>
                <div class="col-md-3">
                  <b-form-group
                    class="mb-0 form-label"
                    id="input-group-1"
                    label="Days"
                    label-for="days"
                  >
                    <b-form-select
                      class="form-select"
                      id="days"
                      type="text"
                      autocomplete="off"
                      v-model="filter.day"
                      :options="days"
                      @change="onSubmit"
                    >
                    </b-form-select>
                  </b-form-group>
                </div>
                <div class="col-md-2">
                  <b-button
                    variant="primary"
                    class="ms-2"
                    type="button"
                    @click="onReset"
                    :class="{ disabled: isBtnLoading }"
                  >
                    <i
                      v-if="isBtnLoading"
                      class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                    ></i>
                    Reset
                  </b-button>
                </div>
              </div>
            </b-form>
            <div class="table-responsive mt-5" v-dragscroll="true">
              <table class="table table-bordered mb-0 multiple-data-table">
                <thead v-if="isLoading && roomAvailability.length == 0"></thead>
                <thead v-else-if="isLoading">
                  <tr>
                    <th><span class="th-title">Types Of Room</span></th>
                    <th class="placeholder-glow" v-for="no in 25" :key="no">
                      <span
                        class="placeholder w-100 placeholder-lg th-date"
                      ></span>
                    </th>
                  </tr>
                </thead>
                <thead v-else>
                  <tr>
                    <th><span class="th-title">Types Of Room</span></th>
                    <th
                      v-for="(date, index) in dates"
                      :key="index"
                      :class="date.class"
                    >
                      <span class="th-date">{{ formatDate(date.date) }}</span>
                    </th>
                  </tr>
                </thead>
                <tbody v-if="isLoading && roomAvailability.length == 0">
                  <tr>
                    <td colspan="9" class="text-center">
                      <img
                        src="@/assets/images/empty.svg"
                        class="img-fluid"
                        alt=""
                      />
                      <p>
                        <span class="text-secondary">No Data Found</span>
                      </p>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else-if="isLoading">
                  <tr v-for="no in 5" :key="no">
                    <th class="placeholder-glow">
                      <span class="placeholder w-100 placeholder-lg"></span>
                    </th>
                    <td class="placeholder-glow" v-for="no in 25" :key="no">
                      <span class="placeholder w-100 placeholder-lg"></span>
                    </td>
                  </tr>
                  <tr>
                    <td>Total available Rooms</td>
                    <td class="placeholder-glow" v-for="no in 25" :key="no">
                      <span class="placeholder w-100 placeholder-lg"></span>
                    </td>
                  </tr>
                  <tr>
                    <td>Occupancy</td>
                    <td class="placeholder-glow" v-for="no in 25" :key="no">
                      <span class="placeholder w-100 placeholder-lg"></span>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr
                    v-for="(roomType, roomTypeIndex) in roomAvailability"
                    :key="roomTypeIndex"
                  >
                    <th>{{ roomType.name }}</th>
                    <td
                      colspan="9"
                      class="text-center"
                      v-if="roomType.room_availability.length == 0"
                    >
                      <img
                        src="@/assets/images/empty.svg"
                        class="no-data-img"
                        alt=""
                      />
                      <p>
                        <span class="text-secondary">No Data Found</span>
                      </p>
                    </td>
                    <td
                      style="cursor: grab"
                      v-for="(roomRate, key) in roomType.room_availability"
                      :key="key"
                      :class="dates[key].class"
                      @click="selectRoomAvailability(roomRate)"
                    >
                      <span
                        v-b-popover.hover="
                          findOccupancy(
                            roomRate.available_room,
                            roomRate.total_room
                          )
                        "
                        >{{ roomRate.available_room }} /
                        {{ roomRate.total_room }}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>Total available Rooms</td>
                    <td
                      v-for="(total, index) in total"
                      :key="index"
                      :class="dates[index].class"
                    >
                      {{ total.totalAva }} / {{ total.all }}
                    </td>
                  </tr>
                  <tr>
                    <td>Occupancy</td>
                    <td
                      v-for="(total, index) in total"
                      :key="index"
                      :class="dates[index].class"
                    >
                      {{ total.occupancy }}%
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.th-title {
  width: 170px;
  display: block;
}

.th-date {
  width: 55px;
  display: block;
  margin: auto;
}

.table tr th:first-child,
.table td:first-child {
  position: sticky;
  width: 100px;
  left: 0;
  z-index: 4;
  background: #fff;
  box-shadow: 0px 4px 25px rgb(0 0 0 / 10%);
}

.multiple-data-table {
  width: 100%;
  text-align: center;
  border-collapse: separate;
  -webkit-overflow-scrolling: touch;
  touch-action: pan-x;
  /* Don't collapse */
  border-spacing: 0;
}

.highlight {
  background-color: #e7f8ff;
}

.no-data-img {
  height: 40px;
}
</style>
